// Requires keymap.js
export default function (...args)
{
	return {
		captureEvents(_this = this)
		{
			this.fill();
			this.safeProtoCall(_this);
		},
	};
}

